import { render, staticRenderFns } from "./communityactivityDetail.vue?vue&type=template&id=b9c7f534&"
import script from "./communityactivityDetail.vue?vue&type=script&lang=js&"
export * from "./communityactivityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports